import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "components/AppIcon";
import { ROUTES } from "config/navConfig";

const metrics = [
  {
    id: "aum",
    label: "AUM Tracked",
    value: "£2.47B",
    change: "+12.4%",
    changePositive: true,
    subtext: "Across 14 assets",
    icon: "TrendingUp",
    iconColor: "var(--color-primary)",
    iconBg: "rgba(59,76,76,0.08)",
    route: ROUTES.dashboard,
  },
  {
    id: "spvs",
    label: "Active SPVs",
    value: "8",
    change: "+2 this quarter",
    changePositive: true,
    subtext: "2 in closing",
    icon: "Briefcase",
    iconColor: "var(--color-primary)",
    iconBg: "rgba(59,76,76,0.12)",
    route: ROUTES.spvDashboard,
  },
  {
    id: "deployed",
    label: "Capital Deployed",
    value: "£1.83B",
    change: "74.1% of AUM",
    changePositive: true,
    subtext: "£640M uncommitted",
    icon: "PoundSterling",
    iconColor: "var(--color-success)",
    iconBg: "rgba(5,150,105,0.08)",
    route: ROUTES.dashboard,
  },
  {
    id: "irr",
    label: "Blended Net IRR",
    value: "11.3%",
    change: "+0.8% vs target",
    changePositive: true,
    subtext: "Target: 10.5%",
    icon: "BarChart3",
    iconColor: "#7C3AED",
    iconBg: "rgba(124,58,237,0.08)",
    route: ROUTES.dashboard,
  },
  {
    id: "distributions",
    label: "YTD Distributions",
    value: "£94.2M",
    change: "Q1 2026",
    changePositive: true,
    subtext: "Next: Apr 2026",
    icon: "ArrowDownCircle",
    iconColor: "var(--color-secondary)",
    iconBg: "rgba(74,107,138,0.08)",
    route: ROUTES.dashboard,
  },
  {
    id: "esg",
    label: "ESG Score",
    value: "82 / 100",
    change: "+4 pts YoY",
    changePositive: true,
    subtext: "SFDR Article 9",
    icon: "Leaf",
    iconColor: "#059669",
    iconBg: "rgba(5,150,105,0.08)",
    route: ROUTES.esgReporting,
  },
];

export default function MetricsGrid() {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
      {metrics?.map((m) => (
        <button
          key={m?.id}
          onClick={() => navigate(m?.route)}
          className="card card-interactive text-left hover-lift press-effect transition-all duration-250 focus:outline-none focus-visible:ring-2"
          style={{ padding: "20px 24px" }}
          aria-label={`${m?.label}: ${m?.value}`}
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex-1 min-w-0">
              <p
                className="font-caption text-muted-foreground mb-1 truncate"
                style={{ fontSize: "0.75rem", letterSpacing: "0.05em", textTransform: "uppercase" }}
              >
                {m?.label}
              </p>
              <p
                className="font-heading font-semibold text-foreground"
                style={{ fontSize: "1.75rem", lineHeight: 1.2 }}
              >
                {m?.value}
              </p>
              <div className="flex items-center gap-1.5 mt-1.5">
                <span
                  className="font-caption text-xs font-medium"
                  style={{ color: m?.changePositive ? "var(--color-success)" : "var(--color-error)" }}
                >
                  {m?.change}
                </span>
                <span className="font-caption text-muted-foreground text-xs">· {m?.subtext}</span>
              </div>
            </div>
            <div
              className="flex-shrink-0 flex items-center justify-center w-11 h-11 rounded-lg"
              style={{ background: m?.iconBg }}
            >
              <Icon name={m?.icon} size={22} color={m?.iconColor} strokeWidth={1.8} />
            </div>
          </div>
        </button>
      ))}
    </div>
  );
}